import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M16.546 13.887V7.275c0-.727-1.091-.727-1.091 0v6.612a2.19 2.19 0 0 0-1.568 1.567H8.909c-.727 0-.727 1.092 0 1.092h4.978a2.183 2.183 0 1 0 2.659-2.66M16 17.09a1.09 1.09 0 1 0 0-2.182 1.09 1.09 0 0 0 0 2.182M5.09 16c0 6.026 4.885 10.91 10.91 10.91S26.91 22.024 26.91 16 22.025 5.09 16 5.09 5.09 9.976 5.09 16M4 16C4 9.372 9.372 4 16 4s12 5.372 12 12-5.372 12-12 12S4 22.628 4 16",
      clipRule: "evenodd"
    }
  )
);
var SvgClockOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ClockOutlined_default = SvgClockOutlined;

export { ClockOutlined_default as default };
